export default __webpack_public_path__ + "static/media/ferocioussmack2.4275e906.png";